import { createAction } from 'redux-actions';
import {
  VERIFY_MODIFY_BOOKING,
  VERIFY_MODIFY_BOOKING_ERROR,
  VERIFY_MODIFY_BOOKING_SUCCESS,
  CANCEL_BOOKING,
  CANCEL_BOOKING_ERROR,
  CANCEL_BOOKING_SUCCESS,
  RESCHEDULE_BOOKING,
  RESCHEDULE_BOOKING_ERROR,
  RESCHEDULE_BOOKING_SUCCESS,
  VIEW_APPOINTMENTS,
  VIEW_APPOINTMENTS_ERROR,
  VIEW_APPOINTMENTS_SUCCESS,
  VIEW_GET_OTP,
  VIEW_GET_OTP_ERROR,
  VIEW_GET_OTP_SUCCESS,
} from './type';

export const viewGetOtpAction = createAction(VIEW_GET_OTP);
export const viewGetOtpActionSuccess = createAction(VIEW_GET_OTP_SUCCESS);
export const viewGetOtpActionError = createAction(VIEW_GET_OTP_ERROR);

export const viewAppointmentsAction = createAction(VIEW_APPOINTMENTS);
export const viewAppointmentsActionSuccess = createAction(
  VIEW_APPOINTMENTS_SUCCESS,
);
export const viewAppointmentsActionError = createAction(
  VIEW_APPOINTMENTS_ERROR,
);

export const verifyModifyBookingAction = createAction(VERIFY_MODIFY_BOOKING);
export const verifyModifyBookingActionSuccess = createAction(
  VERIFY_MODIFY_BOOKING_SUCCESS,
);
export const verifyModifyBookingActionError = createAction(
  VERIFY_MODIFY_BOOKING_ERROR,
);

export const cancelBookingAction = createAction(CANCEL_BOOKING);
export const cancelBookingActionSuccess = createAction(CANCEL_BOOKING_SUCCESS);
export const cancelBookingActionError = createAction(CANCEL_BOOKING_ERROR);

export const rescheduleBookingAction = createAction(RESCHEDULE_BOOKING);
export const rescheduleBookingActionSuccess = createAction(
  RESCHEDULE_BOOKING_SUCCESS,
);
export const rescheduleBookingActionError = createAction(
  RESCHEDULE_BOOKING_ERROR,
);
